export default class extends Controller {

  connect(){
    $('[data-toggle="tooltip"]').tooltip()
  }

}
